import {
    GET_SELLER_DETAILS,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './sellerTypes'
export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_SELLER_DETAILS:
            return {
                ...state,
                seller_details: action.payload,
            }

        default:
            return state
    }
}
